module.exports = __webpack_public_path__ + "static/media/portfolio.740159ed.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio.jpeg
// module id = 118
// module chunks = 0